/**
 * This config needs to be separate from ./i18n.ts in order to support __mocks__/react-i18next.tsx
 */
import { DEFAULT_LANGUAGE_CODE, DEFAULT_LOCALE_CODE, LOCALES } from 'i18n/constants';
import { getDataCenter, getDefaultLocale } from 'i18n/helpers';
import { formatter } from 'i18n/interpolation-formatter';
import * as i18next from 'i18next';

// init i18n and inject hardcoded translations
import resources from '../locales';
import { LanguageCode } from './types';

const CURRENT_DATA_CENTER = getDataCenter();
export const CURRENT_I18N_KEY = `${CURRENT_DATA_CENTER.code}.Locale`;

export const baseConfig: i18next.InitOptions = {
  resources,
  debug: process.env.NODE_ENV === 'development',
  fallbackLng: {
    'de-AT': ['de-DE'],
    'ca-FR': ['ca-EN'],
    'default': Array.from(new Set([
      getDefaultLocale().code,
      DEFAULT_LOCALE_CODE
    ]))
  },
  ns: ['common'],
  defaultNS: 'common',
  supportedLngs: [DEFAULT_LANGUAGE_CODE, LanguageCode.FRENCH, ...Object.keys(LOCALES)],

  partialBundledLanguages: true,

  saveMissing: true,
  missingKeyHandler: (lng, namespace, key) => {
    const message = `Failed to load ${namespace}:${key} for locale ${lng}`;
    if (process.env.NODE_ENV === 'development') console.error(message);
  },

  detection: {
    // order and from where user language should be detected
    order: ['querystring', 'localStorage', 'cookie', 'navigator', 'htmlTag', 'path'],

    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupLocalStorage: CURRENT_I18N_KEY,
    lookupCookie: 'i18next',

    // Do not cache the user's selected language
    caches: [],
  },

  interpolation: {
    escapeValue: false, // explicitly set to false for usage with react
    format: formatter,
  },

  react: { useSuspense: true },
};
